import ApiService from "@/services/apiservice";
import {
  USER_PARTNER_LIST,
  DELETE_PARTNER_USER,
  CREATE_PARTNER_USER,
  CHANGE_PARTNER_USER_STATUS,
  PARTNER_ROLES,
  EDIT_PARTNER_USER_STATUS,
  GET_PARTNER_USER,
  PARTNER_PATIENT_LIST,
  CREATE_PARTNER_PATIENT,
  GET_PARTNER_PATIENT,
  DELETE_PARTNER_PATIENT,
  EDIT_PARTNER_PATIENT,
  UPDATE_STATUS_PARTNER_PATIENT,
  REGISTER_PATIENT,
  CREATE_PATIENT_DETAILS,
  GET_PATIENT_DETAILS,
  EDIT_PATIENT_DETAILS,
  GET_SERVEY_DETAILS,
  GET_SERVEY_SUMMARY, 
  GET_VR_TEST_RESULT_HISTORY,
  GET_VR_TEST_RESULT_DETAIL,
  GET_SERVEYMESAGES,
  POST_SERVEYMESAGES,
  GET_PARTNER_ABOUT,
  EDIT_PARTNER_ABOUT,
  PARTNER_PATIENT_SEARCH,
  GET_PARTNERS_USERS_COUNT,
  GET_PARTNER_NOTIFICATION_LIST,
  CREATE_PARTNER_STORE,
  GET_PARTNER_STORES,
  GET_PARTNER_STORE,
  EDIT_PARTNER_STORE,
  UPDATE_BRANCH_STATUS,
  DELETE_PARTNER_BRANCH,


} from "./actions.type";
import { SET_PARTNER_USER_LIST, SET_PARTNER_PATIENT_LIST, SET_PATIENT_LIST,SET_PARTNER_NOTIFICATION_LIST,SET_PARTNER_STORES  } from "./mutations.type";

import { _ } from "core-js";

const getDefaultState = () => {
  return {
    partnerUserList: { list: [], pageTotal: 0 },
    partnerPatintList: { list: [], pageTotal: 0 },
    patientList: { list: [], pageTotal: 0 },
    PartnernotificationList:{ list: [], pageTotal: 0 },
    partnerBranchListP: { list: [], pageTotal: 0 },
  };
};
const state = getDefaultState();

const actions = {
  async [CREATE_PARTNER_USER](context, payload) {
    let { data } = await ApiService.post("partnermanager/master", payload);
    return data;
  },
  async [CHANGE_PARTNER_USER_STATUS](context, payload) {
    console.log("payload 123", payload)
    let { data } = await ApiService.patch("partnermanager/partnerstatus/" + payload.id, payload);
    return data;
  },
  async [USER_PARTNER_LIST](context, payload) {
    let { data } = await ApiService.get("partnermanager/masters", payload);
    context.commit(SET_PARTNER_USER_LIST, data);
  },
  async [GET_PARTNER_USER](context, payload) {
    let { data } = await ApiService.get("partnermanager/master/" + payload.id, "");
    return data;
  },
  async [DELETE_PARTNER_USER](context, payload) {
    let { data } = await ApiService.delete(
      "partnermanager/master/" + payload.id,
      ""
    );
    return data;
  },
  async [EDIT_PARTNER_USER_STATUS](context, payload) {
    try {
      let { data } = await ApiService.put("partnermanager/master/" + payload.id, payload);
      return data;
    } catch (error) {
      return false;
    }
  },
  async [PARTNER_ROLES](context, payload) {
    let { data } = await ApiService.get("roles/partner", payload);
    return data;
  },

  async [GET_SERVEY_DETAILS](context, payload) {
    let { data } = await ApiService.get("survey/partner", payload);
    return data;
  },

  async [GET_SERVEY_SUMMARY](context, payload) {
    let { data } = await ApiService.get("survey/summary_and_questions_and_answers", payload);
    return data;
  },  

  async [GET_VR_TEST_RESULT_HISTORY](context, payload) {
    let { data } = await ApiService.get("vr_brain_functional_test_results/" + payload.patientId, payload);
    return data;
  },
  async [GET_VR_TEST_RESULT_DETAIL](context, payload) {
    let { data } = await ApiService.get("vr_brain_functional_test_results/" + payload.patientId + "/" + payload.vrTestResultId,  payload);
    return data;
  },

  async [CREATE_PARTNER_PATIENT](context, payload) {
    let { data } = await ApiService.post("partnermanager/master", payload);
    return data;
  },
  async [UPDATE_STATUS_PARTNER_PATIENT](context, payload) {
    console.log("payload 123", payload)
    let { data } = await ApiService.patch("partnermanager/partnerstatus/" + payload.id, payload);
    return data;
  },
  async [PARTNER_PATIENT_LIST](context, payload) {
    let { data } = await ApiService.get("partnermanager/masters", payload);
    context.commit(SET_PARTNER_PATIENT_LIST, data);
  },
  async [GET_PARTNER_PATIENT](context, payload) {
    let { data } = await ApiService.get("partnermanager/master/" + payload.id, "");
    return data;
  },
  async [DELETE_PARTNER_PATIENT](context, payload) {
    let { data } = await ApiService.delete(
      "partnermanager/master/" + payload.id,
      ""
    );
    return data;
  },
  async [EDIT_PARTNER_PATIENT](context, payload) {
    try {
      let { data } = await ApiService.put("partnermanager/master/" + payload.id, payload);
      return data;
    } catch (error) {
      return false;
    }
  },
  async [REGISTER_PATIENT](context, payload) {
    try {
      let { data } = await ApiService.post("patientsearchdetails", payload);

      return data;
    } catch (error) {
      return false;
    }
    return data;
  },
  async [CREATE_PATIENT_DETAILS](context, payload) {
    try {
      let { data } = await ApiService.post("patientdetail", payload);

      return data;
    } catch (error) { }
    return data;
  },
  async [PARTNER_PATIENT_LIST](context, payload) {
    let { data } = await ApiService.get("patientdetails", payload);
    context.commit(SET_PATIENT_LIST, data);
  },
  async [DELETE_PARTNER_PATIENT](context, payload) {
    let { data } = await ApiService.delete("patientdetail/" + payload.id, "");
    return data;
  },
  async [GET_PATIENT_DETAILS](context, payload) {
    let { data } = await ApiService.get("patientdetail/" + payload.id, "");

    return data;
  },
  async [EDIT_PATIENT_DETAILS](context, payload) {
    try {
      let { data } = await ApiService.post("patientdetail/" + payload.id, payload);
      return data;
    } catch (error) {
      return false;
    }
  },
  async [UPDATE_STATUS_PARTNER_PATIENT](context, payload) {
    try {
      let { data } = await ApiService.patch("patientdetail/" + payload.id, payload);

      return data;
    } catch (error) {
      return error;
    }
  },
  async [GET_SERVEYMESAGES](context, payload) {
    let { data } = await ApiService.get("doctormessages", payload);
    return data;
  },
  async [POST_SERVEYMESAGES](context, payload) {
    let { data } = await ApiService.post("doctormessage", payload);
    return data;
  },
  async [GET_PARTNER_ABOUT](context, payload) {
    try {
      let { data } = await ApiService.get("partner/aboutdetails", payload);
      return data;

    } catch (error) {
      return ({
        status: false,
        message: "Server error"
      })
    }
  },
  async [EDIT_PARTNER_ABOUT](context, payload) {
    let { data } = await ApiService.post("partner/aboutdetails", payload);
    return data;
  },
  async [PARTNER_PATIENT_SEARCH](context, payload) {
    let { data } = await ApiService.get("patientdetails", payload);
    context.commit(SET_PATIENT_LIST, data);
  },
  async [GET_PARTNERS_USERS_COUNT](context, payload) {
    let { data } = await ApiService.get("partner/dashboard");
   return data;
 },
 async [GET_PARTNER_NOTIFICATION_LIST](context, payload) {
  let { data } = await ApiService.get("users/notifications" , payload);
context.commit(SET_PARTNER_NOTIFICATION_LIST, data);
return data;
},
  async [CREATE_PARTNER_STORE](context, payload) {
    let { data } = await ApiService.post("partner/branch", payload);
    return data;
  },
  async [GET_PARTNER_STORES](context, payload) {
    let { data } = await ApiService.get("partner/branches", payload);
    context.commit(SET_PARTNER_STORES, data);
  },
  async [GET_PARTNER_STORE](context, payload) {
    let { data } = await ApiService.get("partner/branch/" + payload.id, "");

    return data;
  },
  async [EDIT_PARTNER_STORE](context, payload) {
    let { data } = await ApiService.put("partner/branch/" + payload.id, payload);
    return data;
  },
  async [UPDATE_BRANCH_STATUS](context, payload) {
    try {
      let { data } = await ApiService.patch("partner/branch/" + payload.id, payload);

      return data;
    } catch (error) {
      return error;
    }
  },
  async [DELETE_PARTNER_BRANCH](context, payload) {
    let { data } = await ApiService.delete("partner/branch/" + payload.id, "");
    return data;
  },
};

const mutations = {
  [SET_PARTNER_USER_LIST](state, response) {
    Object.assign(state.partnerUserList, { list: [], pageTotal: 0 })
    state.partnerUserList = {
      list: _.get(response, "partners", []),
      pageTotal: _.get(response, "page.total", 0)
    };
  },
  [SET_PARTNER_PATIENT_LIST](state, response) {
    state.partnerPatintList = {
      list: _.get(response, "partners", []),
      pageTotal: _.get(response, "page.total", 0)
    };
  },
  [SET_PATIENT_LIST](state, responce) {
    state.patientList = {
      list: _.get(responce, "patient_details", []),
      pageTotal: _.get(responce, "page.total", 0)
    };
  },
  [SET_PARTNER_NOTIFICATION_LIST](state, responce) {
    state.PartnernotificationList = {
      list: _.get(responce, "notifications", []),
      pageTotal: _.get(responce, "page.total", 0)

    }
  },
  [SET_PARTNER_STORES](state, responce) {
    state.partnerBranchListP = {
      list: _.get(responce, "partners", []),
      pageTotal: _.get(responce, "page.total", 0)
    };
  }
};

const getters = {
  partnerUserList(state) {
    return state.partnerUserList;
  },
  patientList(state) {
    return state.patientList;
  },
  partnerNotification(state){
    return state.PartnernotificationList;
  },
  partnerBranchListP(state) {
    return state.partnerBranchListP;
  }
};
export default {
  state,
  actions,
  mutations,
  getters
};
